module.exports = __webpack_public_path__ + "kudos_57.svg?3fcde4a317d18c870d7adeb56b89aa7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_57.svg
// module id = 158
// module chunks = 0